import { createContext, useState, useCallback, useEffect } from "react";
import useLocalStorage from '../hooks/useLocalStorage'
import decode from 'jwt-decode'

export const AuthContext = createContext()

export const AuthProvider = ({children}) => {
	const [user, setUser] = useState(null)
	const [token, setToken] = useLocalStorage('token', '')
	const [awsAccessKeyId, setAwsAccessKeyId] = useLocalStorage('awsAccessKeyId', '')
	const [awsSecretAccessKey, setAwsSecretAccessKey] = useLocalStorage('awsSecretAccessKey', '')
	const [awsSessionToken, setAwsSessionToken] = useLocalStorage('awsSessionToken', '')
	const [awsTempCredExpiration, setAwsTempCredExpiration] = useLocalStorage('awsTempCredExpiration', '')

	useEffect(() => {
		if (token) {
			setUser(decode(token))
		}
	},[token])

	const isTokenExpired = token => {
		try {
		  const decoded = decode(token)
		  if (decoded.exp < Date.now() / 1000) {
			// Checking if token is expired
			return true
		  }
		  return false
		} catch (err) {
		  return false
		}
	}

	const isLoggedIn = useCallback(() => {
		// Checks if there is a saved token and it's still valid
		const bool = !!token && !isTokenExpired(token) && !!user // handwaiving here
		return bool
	  }, [user, token])

	  const login = async ({identifier, password}) => {
		const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/local`,
		  {
			headers: {
			  Accept: 'application/json',
			  'Content-Type': 'application/json',
			},
			method: 'POST',
			body: JSON.stringify({identifier, password})
		  }
		)
		
		const json = await res.json()
		setUser(decode(json.jwt))
		setToken(json.jwt)
		setAwsAccessKeyId(json.awsCredentials.AccessKeyId)
		setAwsSecretAccessKey(json.awsCredentials.SecretAccessKey)
		setAwsSessionToken(json.awsCredentials.SessionToken)
		setAwsTempCredExpiration(json.awsCredentials.Expiration)
		return json
	  }

	return (
		<AuthContext.Provider value={{user, setUser, token, setToken, login, isLoggedIn, awsAccessKeyId, awsSecretAccessKey, awsSessionToken, awsTempCredExpiration}} >{children}</AuthContext.Provider>
	)
}